import React from 'react';
import './supplierInvoices.scss';

import { useAuth } from  '../../contexts/auth'; 
import { createStore } from 'devextreme-aspnet-data';
import CustomStore from "devextreme/data/custom_store";

import DataGrid, {
    Column,
    Export,
    Popup,
    Form,
    Button,
    Pager,
    Paging,
    FilterRow,
    HeaderFilter,
    RowDragging,
    Lookup,
    Item,
    Toolbar,
    Editing,
    Selection,
    Summary,
    Format,
    //GroupItem,
    TotalItem,
    SearchPanel
  } from 'devextreme-react/data-grid';

//import { Item} from 'devextreme-react/form';
import { useState, useEffect, useCallback  } from "react";
import { formatNumber } from 'devextreme/localization';
//import notify from "devextreme/ui/notify";

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaFornitoreDettaglio'

export default function SupplierInvoiceDetailRows(props) {

  const filterPayload = { 
    idSuper: props.myKey,
    noNotes: false,
    noHidden: false
  };

  const isEditable = props.status === 1 ? true : false;
  const isUpdateble = props.status !== 3 ? true : false;
  //console.log("Modificabile: " + isEditable);

  const [tipiArticolo, setTipiArticolo] = useState({});
  const [um, setUm] = useState({});
  //const [articoli, setArticoli] = useState({});
  const [imposte, setImposte] = useState({});
  //const [categorie, setCategorie] = useState({});
  const [editableOrder, setEditableOrder] = useState(isEditable);
  const [updatebleOrder, setUpdatebleOrder] = useState(isUpdateble);
  const { user } = useAuth(); 

    useEffect(() => {

      const newServiceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/TipoArticolo';
      var newUrl =  newServiceUrl + "/GetAction";

      const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/UnitaMisura';
      var newUrl2 =  newServiceUrl2 + "/GetAction";

      const newServiceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Imposta';
      var newUrl4 =  newServiceUrl4 + "/GetAction";

        
      const fetchData = async () => {
          try {

              const response = await fetch(newUrl);
              const json = await response.json();
              console.log(json);
              setTipiArticolo(json);

              const response2 = await fetch(newUrl2);
              const json2 = await response2.json();
              console.log(json2);
              setUm(json2);  

              const response4 = await fetch(newUrl4);
              const json4 = await response4.json();
              console.log(json4);
              setImposte(json4);

            

          } catch (error) {
              console.log("error", error);
          }
      };
      fetchData();
    }, []);

    function customizeText(data) {
      return `Righe: ${data.value}`;
    }

    function customizeData(data) {
      return `Totale: ${formatNumber(data.value, '###,##0.00')}`;
    }

    function onInitNewRow(e) {
      e.data.fatturaId = props.myKey;
    };

    
  const onEditorPreparing = (e) => {
    if (e.parentType === "dataRow" && e.dataField === "articoloId") {
      //e.editorOptions.disabled = typeof e.row.data.tipoRigaId !== "number";
      e.editorOptions.disabled = typeof e.row.data.categoriaId !== "number";
      //notify(error, 'Modificato', 5000);
      //notify(`Modificato`, { type: 'warning' });
    }
  }

  const remoteDataSource = createStore({

    key: 'id',
    loadUrl: serviceUrl + '/Find',
    
    onBeforeSend: (method, ajaxOptions) => {
      if (method == "load" ) {    
        //console.log("CHIAVE: " + filterPayload.idSuper);       
        var payload = ajaxOptions.data;
        payload.values = JSON.stringify(filterPayload);
        ajaxOptions.data = payload;          
      }  
    ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
    ;
    },
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction'
      
  });

    function calculateImportoTotale(rowData) {
      return (rowData.importoUnitario - (rowData.importoUnitario / 100 * rowData.percSconto)) * rowData.quantità;
    };


    function onReorder(e) {
      e.promise = processReorder(e);
    }
  
    async function processReorder(e) {
      
      const visibleRows = e.component.getVisibleRows();
      const newOrderIndex = visibleRows[e.toIndex].data.orderIndex;
  
      await remoteDataSource.update(e.itemData.id, { orderIndex: newOrderIndex });
      await e.component.refresh();
    }

    function onRowInserting(e) {
      e.data.createBy = user.name;
    };

    function onRowUpdating(e) {
      e.newData.updateBy = user.name;
    };

    // const onCellPrepared = (e) => {
   
    //   const today = new Date();
    //   const yyyy = today.getFullYear();
    //   let mm = today.getMonth() + 1; // month is zero-based
    //   let dd = today.getDate();
      
    //   if (dd < 10) dd = '0' + dd;
    //   if (mm < 10) mm = '0' + mm;
      
    //   const todayFormatted = yyyy + '-' + mm + '-' + dd + 'T00:00:00';

    //   if (e.rowType === "data") {
    //       if (e.column.dataField === "dataScadenza") 
    //       { 
    //         console.log("OGGI: " + todayFormatted);
    //         var dataScadenza = e.data.dataScadenza;
    //         console.log("CONSEGNA: " + dataScadenza);
    //         if (dataScadenza < todayFormatted)
    //         {
    //           e.cellElement.style.cssText = "color: red";
    //         }
    //       }
    //   }
    // }

    return (
  
        <div>


        <DataGrid id="grid-container"
            dataSource={remoteDataSource}
            showBorders={true}
            columnAutoWidth={true}
            onInitNewRow={onInitNewRow}
            onEditorPreparing={onEditorPreparing}
            onRowUpdating={onRowUpdating}
            onRowInserting={onRowInserting}
            //onCellPrepared={onCellPrepared}
            //onToolbarPreparing = {onToolbarPreparing}
        >
          <Paging  defaultPageSize={40}/>
          <Pager showPageSizeSelector={true} showInfo={true} />


          <RowDragging
            allowReordering={editableOrder}
            onReorder={onReorder}
            dropFeedbackMode="push"
          />

            <HeaderFilter visible={true} />
            <Summary>
            <TotalItem
                column="codice"
                summaryType="count"
                customizeText={customizeText}
            />
            <TotalItem
              column="paTotale"
              summaryType="sum" 
              customizeText={customizeData}
              />
            </Summary>
            <Selection mode="single" />
            <Editing
              mode="row"
              allowUpdating={updatebleOrder}
              allowAdding={editableOrder}
              allowDeleting={editableOrder}
              useIcons={true}
            >
              
            </Editing>
            <Column dataField="id" visible={false}/>
            <Column dataField="fatturaId" visible={false}/>
            
            
            <Column dataField="codiceAlias" caption="Codice" width={100} allowEditing={editableOrder}/>
            <Column dataField="descrizione" caption="Descrizione" width={480} allowEditing={editableOrder}/>
            
            <Column dataField="tipoRigaId" caption="Tipo"  width={60}  allowEditing={false} visible={false}>
                <Lookup dataSource={tipiArticolo} valueExpr="id" displayExpr="codice"/>
            </Column>
            <Column dataField="impostaId" caption="IVA" width={60} allowEditing={editableOrder}>
                <Lookup dataSource={imposte} valueExpr="id" displayExpr="codice" />
            </Column> 
            <Column dataField="umid" caption="UM" width={60} allowEditing={editableOrder}>
                <Lookup dataSource={um} valueExpr="id" displayExpr="codice" />
            </Column>
            <Column dataField="quantità" caption="Q.tà" width={80} allowEditing={editableOrder}/>
            <Column dataField="importoUnitario" caption="Importo Unit." allowEditing={editableOrder}>
                <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="percSconto" caption="% Sconto" allowEditing={editableOrder}>
                <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="importoScontato"  caption="Importo Scontato" allowEditing={editableOrder}>
                <Format type="fixedPoint" precision={2} />
            </Column>
            <Column dataField="importoTotale" calculateCellValue={calculateImportoTotale} caption="Totale" allowEditing={false}>
                <Format type="fixedPoint" precision={2} />
            </Column> 

            <Column dataField="updateBy" visible={false}/>
            <Column dataField="createBy" visible={false}/> 
        </DataGrid>

        </div>  
   
   )
};